// import _ from 'lodash'
import { SPECIAL_COLUMN } from '@/components/tool-group/index.js'

export const columns1 = [
  //基础数据
  {
    id: 'pictureasin',
    title: '图片',
    field: 'imageUrl',
    fixed: 'left',
    width: '100px',
    slots: {
      default: 'image'
    },
    default: true,
    disabled: true,
    // treeNode: true,
  },
  {
    id: 'listingInfo',
    title: 'ASIN/售价',
    field: 'listingInfo',
    fixed: 'left',
    width: '130px',
    slots: {
      default: 'listingInfo',
      // header:'listingInfo-header'
    },
    default: true,
    disabled: true,
    sortable: true,
      sortBy: ''
  },
  {
    id: 'asins',
    title: 'ASIN分析',
    field: 'asins',
    width: '100px',
    fixed: 'left',
    slots: {
      default: 'asins'
    },
    default: true,
    disabled: true,
    exist: true,
  },
  {
    id: 'marketId',
    title: '店铺/国家',
    field: 'listingMarketName',
    width: '120px',
    fixed: 'left',
    slots: {
      default: 'listingMarketName'
    },
    default: true,
    disabled: true
  },
  {
    id: 'asin',
    title: 'ASIN',
    field: 'asin',
    width: '130px',
    slots: {
      default: 'asin'
    },
    default: true,
    exist: false,
    sortable: true
  },
  {
    id: 'crawlTitle',
    title: '商品标题',
    field: 'crawlTitle',
    width: '160px',
    sortable: false,
    default: false,
    slots: {
      default: 'crawlTitle',
    }
  },
  {
    id: 'parentAsin',
    title: '父ASIN',
    field: 'variationAsin',
    width: '130px',
    slots: {
      default: 'variationAsin'
    },
    default: true,
    copyable: true,
    exist: true,
    sortable: true
  },
  {
    id: 'categoryName',
    title: '品类',
    field: 'categoryName',
    width: '140px',
    sortable: false,
    default: false,
    slots: {
      default: 'categoryName',
    }
  },
  {
    id: 'product',
    title: '产品名称/SKU',
    field: 'product',
    width: '180px',
    slots: {
      default: 'product'
    },
    default: true,
    disabled: false,
    sortable: true,
      sortBy: 'sku'
  },
  {
    id: 'brandName',
    title: '品牌',
    field: 'brandName',
    width: '140px',
    sortable: false,
    default: false,
    slots: {
      default: 'brandName',
    }
  },
  {
    id: 'sellingManagerNames',
    title: '负责人',
    field: 'sellingManagerNames',
    width: '140px',
    sortable: false,
    default: false,
    slots: {
      default: 'sellingManagerNames',
    }
  },
  {
    id: 'orders',
    title: '订单量',
    field: 'orders',
    titleHelp: {
      message: '订单中存在多个商品时，合计栏不会重复统计',
    },
    width: '120px',
    sortable: true,
    align: 'right',
    default: true,
    summary: true,
    slots: {
      default: 'orders'
    },
    dataClick: true
  },
  {
    id: 'avgUnitsOrderedSales',
    title: '平均订单价格',
    field: 'avgUnitsOrderedSales',
    width: '140px',
    sortable: false,
    align: 'right',
    prefix: 'currencySymbol',
    titleHelp: {
      message: "平均订单价格=销售额/订单量"
    },
    default: false
  },
  
  {
    id: 'adsOrdersRate',
    title: '广告订单占比',
    field: 'adsOrdersRate',
    width: '140px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "广告订单占比=广告订单量/订单量"
    },
    default: true,
    suffix:"%",
    slots: {
      default: 'adsOrdersRate',
    },
    dataClick: true
  },
  {
    id: 'unitsOrdered',
    title: '销量',
    field: 'unitsOrdered',
    width: '80px',
    sortable: true,
    align: 'right',
    default: true,
    summary: true,
    slots: {
      default: 'unitsOrdered'
    },
    dataClick: true
  },
  {
    id: 'avgOrderItemsSales',
    title: '平均销售价格',
    field: 'avgOrderItemsSales',
    width: '140px',
    sortable: false,
    align: 'right',
    titleHelp: {
      message: "平均销售价格=销售额/销量"
    },
    prefix: 'currencySymbol',
    default: false,
    slots: {
      default: 'avgOrderItemsSales',
    },
    dataClick: true
  },
  {
    id: 'unitsOrderedB2b',
    title: '销量B2B',
    field: 'unitsOrderedB2b',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    slots: {
      default: 'unitsOrderedB2b',
    },
    dataClick: true
  },
  {
    id: 'multiChannelOrders',
    title: '多渠道销量',
    field: 'multiChannelOrders',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    slots: {
      default: 'multiChannelOrders',
    },
    dataClick: true
  },
  {
    id: 'orderProductSales',
    title: '销售额',
    field: 'orderProductSales',
    width: '100px',
    sortable: true,
    align: 'right',
    default: true,
    prefix: 'currencySymbol',
    summary: true,
    slots: {
      default: 'orderProductSales'
    },
    dataClick: true
  },
  {
    id: 'orderProductSalesB2b',
    title: '销售额B2B',
    field: 'orderProductSalesB2b',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    slots: {
      default: 'orderProductSalesB2b',
    },
    dataClick: true
  },
  {
    id: 'adsSales',
    title: '广告销售额',
    field: 'adsSales',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    default: true,
    prefix: 'currencySymbol',
    summary: true,
    slots: {
      default: "adsSales"
    },
    dataClick: true
  },
  {
    id: 'discountCost',
    title: '促销折扣',
    field: 'discountCost',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    prefix: 'currencySymbol',
    slots: {
      default: 'discountCost',
    },
    dataClick: true
  },
  {
    id: 'realOrderProductSales',
    title: '实际销售额',
    field: 'realOrderProductSales',
    width: '140px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "实际销售额=销售额-促销折扣"
    },
    default: true,
    prefix: 'currencySymbol',
    slots: {
      default: 'realOrderProductSales',
    },
    dataClick: true
  },
  {
    id: 'returns',
    title: '退货量',
    field: 'returns',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    slots: {
      default: 'returns',
    },
    dataClick: true
  },
  {
    id: 'returnProductSales',
    title: '退款销售额',
    field: 'returnProductSales',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    slots: {
      default: 'returnProductSales',
    },
    dataClick: true
  },
  {
    id: 'returnsRate',
    title: '退货率',
    field: 'returnsRate',
    width: '140px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "退货率=退货量/销量；按订单退货时间统计"
    },
    suffix:"%",
    default: false,
    slots: {
      default: 'returnsRate',
    },
    dataClick: true
  },
  {
    id: 'refunds',
    title: '退款量',
    field: 'refunds',
    width: '140px',
    sortable: true,
    align: 'right',
    default: false,
    slots: {
      default: 'refunds',
    },
    dataClick: true
  },
  {
    id: 'refundsRate',
    title: '退款率',
    field: 'refundsRate',
    width: '140px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "退款率=退款量/销量；按订单退款时间统计"
    },
    suffix:"%",
    default: false,
    slots: {
      default: 'refundsRate',
    },
    dataClick: true
  },



  {
    id: 'Session',
    title: 'Sessions',
    slots: {
      group:'group:Sessions'
    }
  },
  {
    id: 'sessionsMobile',
    title: SPECIAL_COLUMN.mobile,
    field: 'sessionsMobile',
    minWidth: '90px',
    align: 'center',
    default: true,
    summary: true,
    sortable: true,
    group: {
      id: 'Session',
      label: SPECIAL_COLUMN.mobile
    },
    slots: {
      default: 'sessionsMobile',
    },
    dataClick: true
  },
  {
    id: 'sessionsBrowser',
    title: SPECIAL_COLUMN.PC,
    field: 'sessionsBrowser',
    minWidth: '90px',
    align: 'center',
    default: true,
    summary: true,
    sortable: true,
    group: {
      id: 'Session',
      label: SPECIAL_COLUMN.PC
    },
    slots: {
      default: 'sessionsBrowser',
    },
    dataClick: true
  },
  {
    id: 'sessions',
    title: SPECIAL_COLUMN.total,
    field: 'sessions',
    minWidth: '100px',
    align: 'center',
    default: true,
    summary: true,
    sortable: true,
    group: {
      id: 'Session',
      label: SPECIAL_COLUMN.total
    },
    slots: {
      default: 'sessions',
    },
    dataClick: true
  },
  {
    id: 'PV',
    title: 'PV',
    slots: {
      group:'group:PV'
    }
  },
  {
    id: 'pageViewsMobile',
    title: SPECIAL_COLUMN.mobile,
    field: 'pageViewsMobile',
    minWidth: '90px',
    align: 'center',
    default: true,
    summary: true,
    sortable: true,
    group: {
      id: 'PV',
      label: SPECIAL_COLUMN.mobile
    },
    slots: {
      default: 'pageViewsMobile',
    },
    dataClick: true
  },
  {
    id: 'pageViewsBrowser',
    title: SPECIAL_COLUMN.PC,
    field: 'pageViewsBrowser',
    minWidth: '90px',
    align: 'center',
    default: true,
    summary: true,
    sortable: true,
    group: {
      id: 'PV',
      label: SPECIAL_COLUMN.PC
    },
    slots: {
      default: 'pageViewsBrowser',
    },
    dataClick: true
  },
  {
    id: 'pageViews',
    title: SPECIAL_COLUMN.total,
    field: 'pageViews',
    minWidth: '90px',
    align: 'center',
    default: true,
    summary: true,
    sortable: true,
    group: {
      id: 'PV',
      label: SPECIAL_COLUMN.total
    },
    slots: {
      default: 'pageViews',
    },
    dataClick: true
  },
  {
    id: 'unitSessionPercentage',
    title: 'CVR',
    field: 'unitSessionPercentage',
    // titleHelp: {
    //   message: `转化率=销量/Sessions`
    // },
    minWidth: '120px',
    align: 'right',
    default: true,
    summary: true,
    suffix:"%",
    sortable: true,
    slots: {
      default: 'unitSessionPercentage',
      header:'header:CVR'
    },
    dataClick: true
  },
  {
    id: 'buyBoxPercentage',
    title: 'BuyBox',
    field: 'buyBoxPercentage',
    // titleHelp: {
    //   message: `BuyBox`
    // },
    minWidth: '120px',
    align: 'right',
    default: true,
    summary: true,
    suffix:"%",
    sortable: true,
    slots: {
      default: 'buyBoxPercentage',
      header:'header:BuyBox'
    },
    dataClick: true
  },
  {
    id: 'adsImpressions',
    title: '广告曝光量',
    field: 'adsImpressions',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    default: true,
    summary: true,
    slots: {
      default: "adsImpressions"
    },
    dataClick: true
  },
  {
    id: 'adsClicks',
    title: '广告点击量',
    field: 'adsClicks',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    default: true,
    summary: true,
    slots: {
      default: "adsClicks"
    },
    dataClick: true
  },
  {
    id: 'adsOrders',
    title: '广告订单量',
    field: 'adsOrders',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    summary: true,
    default: true,
    slots: {
      default: "adsOrders"
    },
    dataClick: true
  },
  {
    id: 'adsSpend',
    title: '广告花费',
    field: 'adsSpend',
    titleHelp: {
      message: '仅包含商品广告、展示广告的费用，不包含品牌广告的费用'
    },
    minWidth: '110px',
    sortable: true,
    align: 'right',
    default: true,
    prefix: 'currencySymbol',
    summary: true,
    slots: {
      default: "adsSpend"
    },
    dataClick: true
  },
  {
    id: 'cpc',
    title: 'CPC',
    field: 'cpc',
    minWidth: '90px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: '每次点击费用=广告花费/广告点击量'
    },
    prefix: 'currencySymbol',
    summary: true,
    default: true,
    slots: {
      default: "cpc"
    },
    dataClick: true
  },
  {
    id: 'cr',
    title: '广告CVR',
    field: 'cr',
    minWidth: '110px',
    sortable: true,
    align: 'right',
    default: true,
    titleHelp: {
      message: '广告转化率=广告订单量/广告点击量'
    },
    suffix:"%",
    summary: true,
    slots: {
      default: "cr"
    },
    dataClick: true
  },
  {
    id: 'ctr',
    title: 'CTR',
    field: 'ctr',
    minWidth: '90px',
    sortable: true,
    align: 'right',
    default: true,
    titleHelp: {
      message: '广告点击率=广告点击量/广告曝光量'
    },
    suffix:"%",
    summary: true,
    slots: {
      default: "ctr"
    },
    dataClick: true
  },
  
 
  
  {
    id: 'acoS',
    title: 'ACOS',
    field: 'acoS',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "ACOS=广告花费/广告销售额"
    },
    suffix:"%",
    default: true,
    summary: true,
    slots: {
      default: "acoS"
    },
    dataClick: true
  },
  {
    id: 'acoAS',
    title: 'ACOAS',
    field: 'acoAS',
    minWidth: '110px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: 'ACOAS=广告花费/销售额'
    },
    suffix:"%",
    summary: true,
    default: true,
    slots: {
      default: "acoAS"
    },
    dataClick: true
  },
  {
    id: 'asoAS',
    title: 'ASOAS',
    field: 'asoAS',
    minWidth: '110px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: 'ASOAS=广告销售额/销售额'
    },
    suffix:"%",
    summary: true,
    default: true,
    slots: {
      default: "asoAS"
    },
    dataClick: true
  },
  {
    id: 'roAS',
    title: 'ROAS',
    field: 'roAS',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "ROAS=广告销售额/广告花费"
    },
    suffix:"%",
    summary: true,
    default: true,
    slots: {
      default: "roAS"
    },
    dataClick: true
  },



  {
    id: 'fulfillableQuantity',
    title: 'FBA可售',
    titleHelp: {
      message: "当前FBA仓库可售量"
    },
    field: 'fulfillableQuantity',
    slots: {
      default: 'fulfillableQuantity'
    },
    summary: true,
    align: 'right',
    minWidth: '90px',
    default: true
  },
  {
    id: 'saleableTurnover',
    title: 'FBA可售周转',
    titleHelp: {
      message: "FBA可售周转=FBA可售/7天日均销量"
    },
    field: 'saleableTurnover',
    slots: {
      default: "saleableTurnover"
    },
    summary: true,
    align: 'right',
    minWidth: '120px',
    default: true
  },
  {
    id: 'fulfillableQuantityFBM',
    title: 'FBM可售',
    // titleHelp: {
    //   message: '当前FBM仓库可售量'
    // },
    field: 'fulfillableQuantityFBM',
    slots: {
      default: 'fulfillableQuantityFBM',
      header:'header:fulfillableQuantityFBM'
    },
    summary: true,
    align: 'right',
    minWidth: '100px',
    default: true
  },
  {
    id: 'saleableTurnoverFBM',
    title: 'FBM可售周转',
    titleHelp: {
      message: 'FBM可售周转=FBM可售/7天日均销量'
    },
    field: 'saleableTurnoverFBM',
    slots: {
      default: 'saleableTurnoverFBM'
    },
    summary: true,
    align: 'right',
    minWidth: '120px',
    default: true
  },
  {
    id: 'salesGrossProfit',
    title: '销售毛利',
    permission: 'cost:view',
    field: 'salesGrossProfit',
    width: '110px',
    sortable: true,
    align: 'right',
    prefix: 'currencySymbol',
    titleHelp: {
      message: "可到利润统计模块核算数据"
    },
    summary: true,
    default: true,
    slots: {
      default: "salesGrossProfit"
    },
    dataClick: true
  },
  {
    id: 'grossProfitRate',
    title: '销售毛利率',
    permission: 'cost:view',
    field: 'grossProfitRate',
    width: '120px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: '销售毛利率=销售毛利/销售额'
    },
    suffix:"%",
    summary: true,
    default: true,
    slots: {
      default: "grossProfitRate"
    },
    dataClick: true
  },
  {
    id: 'salesNetProfit',
    title: '销售净毛利',
    permission: 'cost:view',
    field: 'salesNetProfit',
    width: '120px',
    sortable: true,
    align: 'right',
    prefix: 'currencySymbol',
    titleHelp: {
      message: '可到利润统计模块核算数据'
    },
    summary: true,
    default: true,
    slots: {
      default: "salesNetProfit"
    },
    dataClick: true
  },
  {
    id: 'salesNetProfitRate',
    title: '销售净毛利率',
    permission: 'cost:view',
    field: 'salesNetProfitRate',
    width: '140px',
    sortable: true,
    align: 'right',
    titleHelp: {
      message: "销售净毛利率=销售净毛利/销售额"
    },
    suffix:"%",
    summary: true,
    default: true,
    slots: {
      default: "salesNetProfitRate"
    },
    dataClick: true
  },
 
  
 
  
 
 
 
  
  
  // {
  //   id: 'mainCategoryRank',
  //   title: '大类排名',
  //   field: 'mainCategoryRank',
  //   width: '140px',
  //   sortable: false,
  //   default: false,
  //   slots: {
  //     default: 'mainCategoryRank',
  //   },
  //   dataClick: true,
  //   overflowLine: 2
  // },
  // {
  //   id: 'subCategoryRank',
  //   title: '小类排名',
  //   field: 'subCategoryRank',
  //   width: '140px',
  //   sortable: false,
  //   default: false,
  //   slots: {
  //     default: 'subCategoryRank',
  //   },
  //   dataClick: true
  // },
  // {
  //   id: 'star',
  //   title: '评分',
  //   field: 'star',
  //   width: '140px',
  //   sortable: false,
  //   align: 'right',
  //   default: false,
  //   slots: {
  //     default: 'star',
  //   },
  //   dataClick: true
  // },
  // {
  //   id: 'reviewQuantity',
  //   title: '评论数',
  //   field: 'reviewQuantity',
  //   width: '140px',
  //   sortable: false,
  //   align: 'right',
  //   default: false,
  //   slots: {
  //     default: 'reviewQuantity',
  //   },
  //   dataClick: true
  // },
  
]
// /* 添加后缀 */
// const handleSuffix = ({cellValue}) => {
//   return `${cellValue}%`
// }

// /** 添加前缀 柯里化处理 */
// const handlePrefixCurrencySymbol = ({cellValue,row})=> `${row['currencySymbol']}${cellValue}`
  


export const loop_fields = [
  // 销售数据
   { id: 'unitsOrderedB2b', header: '销量B2B', field: 'unitsOrderedB2b'},
   { id: 'orderProductSalesB2b', header: '销售额B2B', field: 'orderProductSalesB2b', prefix: 'currencySymbol'},
   { id: 'multiChannelOrders', header: '多渠道销量', field: 'multiChannelOrders' },
   { id: 'discountCost', header: '促销折扣', field: 'discountCost',prefix: 'currencySymbol' },
   { id: 'realOrderProductSales', header: '实际销售额', field: 'realOrderProductSales', prefix: 'currencySymbol'},
   { id: 'returns', header: '退货量', field: 'returns' },
   { id: 'returnsRate', header: '退货率', field: 'returnsRate', suffix: '%'},
   { id: 'refunds', header: '退款量', field: 'refunds' },
   { id: 'refundsRate', header: '退款率', field: 'refundsRate',  suffix: '%' },
   { id: 'returnProductSales', header: '退款销售额', field: 'returnProductSales', prefix: 'currencySymbol' },
   { id: 'avgOrderItemsSales', header: '平均销售价格', field: 'avgOrderItemsSales',  prefix: 'currencySymbol'},

   //排名
  //  { id: 'star', header: '评论数', field: 'star'},
  //  { id: 'reviewQuantity', header: '评论数', field: 'reviewQuantity'},

  // 广告数据
  { id: 'adsImpressions', header: '广告曝光量', field: 'adsImpressions' },
  { id: 'adsClicks', header: '广告点击量', field: 'adsClicks' },
  { id: 'ctr', header: 'CTR', field: 'ctr', suffix: '%'},
  { id: 'adsSpend', header: '广告花费', field: 'adsSpend', prefix: 'currencySymbol'},
  { id: 'cpc', header: 'CPC', field: 'cpc',  prefix: 'currencySymbol'},
  { id: 'adsOrders', header: '广告订单量', field: 'adsOrders',  },
  { id: 'adsOrdersRate', header: '广告订单量', field: 'adsOrdersRate', suffix:"%"},
  { id: 'cr', header: '广告CVR', field: 'cr',  suffix: '%' },
  { id: 'adsSales', header: '广告销售额', field: 'adsSales',  prefix: 'currencySymbol' },
  { id: 'acoS', header: 'ACOS', field: 'acoS',  suffix: '%' },
  { id: 'acoAS', header: 'ACOAS', field: 'acoAS',  help: 'ACOAS=广告花费/销售额', suffix: '%' },
  { id: 'asoAS', header: 'ASOAS', field: 'asoAS',  suffix: '%'},
  { id: 'roAS', header: 'ROAS', field: 'roAS',  suffix: '%'},
  // 利润数据
  { id: 'salesGrossProfit', header: '销售毛利', field: 'salesGrossProfit',  prefix: 'currencySymbol' } ,
  { id: 'grossProfitRate', header: '销售毛利率', field: 'grossProfitRate',  suffix: '%' } ,
  { id: 'salesNetProfit', header: '销售净毛利', field: 'salesNetProfit',  prefix: 'currencySymbol' } ,
  { id: 'salesNetProfitRate', header: '销售净毛利率',  field: 'salesNetProfitRate',  suffix: '%' } ,
];
